export const MODAL_NAME = "addProjectLink";
